import { render, staticRenderFns } from "./PortalAside.vue?vue&type=template&id=1fba3084&scoped=true&"
import script from "./PortalAside.vue?vue&type=script&lang=js&"
export * from "./PortalAside.vue?vue&type=script&lang=js&"
import style0 from "./PortalAside.vue?vue&type=style&index=0&id=1fba3084&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba3084",
  null
  
)

export default component.exports